import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const Container = styled.div`
	display: flex;
	height: 100%;
	flex-direction: column;
	padding-left: 0;

	${MqTablet} {
		padding-left: 16px;
	}
`;

export const Body = styled.div`
	flex: 1;
	padding-right: 16px;
	padding-bottom: 32px;
	overflow-anchor: none;
	scroll-behavior: smooth;

	${MqTablet} {
		padding-left: 32px;
		margin-left: -32px;
		-webkit-mask-image: linear-gradient(rgba(0, 0, 0, 1) 90%, transparent);
		overflow-y: scroll;
		a:last-child {
			margin-bottom: 20px;
		}
	}
`;

export const ListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;
